import EzController from 'controllers/ez-base-controller';
import Cookies from 'js-cookie';
import { displaySearchPopup } from 'lib/partner-popup-helpers';
import SearchStateManager from 'lib/search-state';
import { getContentType, triggerCustomEvent } from 'lib/helpers';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import { KEYWORD_CLICK } from 'components/analytics/conversions/constants/actions';

export default class SearchTagController extends EzController {
  connect() {
    this.searchState = new SearchStateManager();
    this.flagLoaded();
  }

  sendClickEvent(event) {
    const searchTerm = this.getTagTitle(event.target);

    sendTrackingEvent({
      element: event.target,
      data: {
        action: KEYWORD_CLICK,
        label: `Terms-${searchTerm}`,
        content_type: `Content-${getContentType()}`,
      },
    });

    displaySearchPopup({ searchTerm });
  }

  performSearch(event) {
    this.searchState.updateStateValue('page', 1);
    this.searchState.resetStateToDefault();

    const searchedEventDetail = {
      term: this.getTagTitle(event.target),
      searchPath: this.getSearchPath(event.target),
      useSearchState: true,
    };

    if (event.metaKey && event.code && event.code === 'Enter') {
      searchedEventDetail.searchInNewTab = true;
    }

    Cookies.set('ezSearchType', 'external');

    triggerCustomEvent('Searched', searchedEventDetail);
  }

  getTagTitle(element) {
    return element.getAttribute('title').trim();
  }

  getSearchPath(element) {
    return element.getAttribute('href');
  }

  get searchTerm() {
    const searchInput = document.querySelector('.ez-search-form__input');
    if (!searchInput) {
      return undefined;
    }

    return searchInput.getAttribute('value');
  }
}
